/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as SplatRouteImport } from './routes/$'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedTravelersRouteImport } from './routes/_authenticated/travelers'
import { Route as AuthenticatedChatRouteImport } from './routes/_authenticated/chat'
import { Route as AuthenticatedBookingsRouteImport } from './routes/_authenticated/bookings'
import { Route as AuthenticatedHotelsRouteRouteImport } from './routes/_authenticated/hotels/route'
import { Route as AuthenticatedFlightsRouteRouteImport } from './routes/_authenticated/flights/route'
import { Route as AuthenticatedTripsSearchRouteImport } from './routes/_authenticated/trips/search'
import { Route as AuthenticatedHotelsSearchRouteImport } from './routes/_authenticated/hotels/search'
import { Route as AuthenticatedHotelsExternalRouteImport } from './routes/_authenticated/hotels/external'
import { Route as AuthenticatedFlightsSearchRouteImport } from './routes/_authenticated/flights/search'
import { Route as AuthenticatedFlightsExternalRouteImport } from './routes/_authenticated/flights/external'
import { Route as AuthenticatedTripsTripIdRouteRouteImport } from './routes/_authenticated/trips/$tripId/route'
import { Route as AuthenticatedHotelsHotelsRouteRouteImport } from './routes/_authenticated/hotels/_hotels/route'
import { Route as AuthenticatedFlightsOffersRouteRouteImport } from './routes/_authenticated/flights/_offers/route'
import { Route as AuthenticatedTripsTripIdIndexRouteImport } from './routes/_authenticated/trips/$tripId/index'
import { Route as AuthenticatedTripsTripIdTravellersRouteImport } from './routes/_authenticated/trips/$tripId/travellers'
import { Route as AuthenticatedTripsTripIdSummaryRouteImport } from './routes/_authenticated/trips/$tripId/summary'
import { Route as AuthenticatedTripsTripIdSuccessRouteImport } from './routes/_authenticated/trips/$tripId/success'
import { Route as AuthenticatedTripsTripIdBookingRouteImport } from './routes/_authenticated/trips/$tripId/booking'
import { Route as AuthenticatedHotelsHotelsListRouteImport } from './routes/_authenticated/hotels/_hotels/list'
import { Route as AuthenticatedBookingsScopeIdRouteImport } from './routes/_authenticated/bookings_.$scope.$id'
import { Route as AuthenticatedHotelsHotelsHotelOfferRouteRouteImport } from './routes/_authenticated/hotels/_hotels/_hotel-offer/route'
import { Route as AuthenticatedFlightsOffersOfferRouteRouteImport } from './routes/_authenticated/flights/_offers/offer/route'
import { Route as AuthenticatedHotelsHotelsHotelOfferIdRouteImport } from './routes/_authenticated/hotels/_hotels/_hotel-offer/$id'
import { Route as AuthenticatedFlightsOffersReturnListRouteImport } from './routes/_authenticated/flights/_offers/return/list'
import { Route as AuthenticatedFlightsOffersReturnFareRouteImport } from './routes/_authenticated/flights/_offers/return/fare'
import { Route as AuthenticatedFlightsOffersDepartureListRouteImport } from './routes/_authenticated/flights/_offers/departure/list'
import { Route as AuthenticatedFlightsOffersDepartureFareRouteImport } from './routes/_authenticated/flights/_offers/departure/fare'
import { Route as AuthenticatedHotelsHotelsHotelOfferIdTravellersRouteImport } from './routes/_authenticated/hotels/_hotels/_hotel-offer/$id.travellers'
import { Route as AuthenticatedHotelsHotelsHotelOfferIdSummaryRouteImport } from './routes/_authenticated/hotels/_hotels/_hotel-offer/$id.summary'
import { Route as AuthenticatedHotelsHotelsHotelOfferIdRoomsRouteImport } from './routes/_authenticated/hotels/_hotels/_hotel-offer/$id.rooms'
import { Route as AuthenticatedHotelsHotelsHotelOfferIdPaymentRouteImport } from './routes/_authenticated/hotels/_hotels/_hotel-offer/$id.payment'
import { Route as AuthenticatedHotelsHotelsHotelOfferIdDetailsRouteImport } from './routes/_authenticated/hotels/_hotels/_hotel-offer/$id.details'
import { Route as AuthenticatedHotelsHotelsHotelOfferIdConfirmationRouteImport } from './routes/_authenticated/hotels/_hotels/_hotel-offer/$id.confirmation'
import { Route as AuthenticatedFlightsOffersOfferIdSummaryRouteImport } from './routes/_authenticated/flights/_offers/offer/$id.summary'
import { Route as AuthenticatedFlightsOffersOfferIdPaymentRouteImport } from './routes/_authenticated/flights/_offers/offer/$id.payment'
import { Route as AuthenticatedFlightsOffersOfferIdDetailsRouteImport } from './routes/_authenticated/flights/_offers/offer/$id.details'
import { Route as AuthenticatedFlightsOffersOfferIdConfirmationRouteImport } from './routes/_authenticated/flights/_offers/offer/$id.confirmation'
import { Route as AuthenticatedFlightsOffersOfferIdTravellersIndexRouteImport } from './routes/_authenticated/flights/_offers/offer/$id.travellers/index'
import { Route as AuthenticatedHotelsHotelsHotelOfferIdDetailsImagesRouteImport } from './routes/_authenticated/hotels/_hotels/_hotel-offer/$id.details_.images'
import { Route as AuthenticatedFlightsOffersOfferIdTravellersAdditionalServicesIndexRouteImport } from './routes/_authenticated/flights/_offers/offer/$id.travellers/additional-services/index'
import { Route as AuthenticatedHotelsHotelsHotelOfferIdDetailsImagesFullscreenRouteImport } from './routes/_authenticated/hotels/_hotels/_hotel-offer/$id.details_.images_.fullscreen'
import { Route as AuthenticatedFlightsOffersOfferIdTravellersAdditionalServicesMealSelectionRouteImport } from './routes/_authenticated/flights/_offers/offer/$id.travellers/additional-services/meal-selection'
import { Route as AuthenticatedFlightsOffersOfferIdTravellersAdditionalServicesBaggageSelectionRouteImport } from './routes/_authenticated/flights/_offers/offer/$id.travellers/additional-services/baggage-selection'
import { Route as AuthenticatedHotelsHotelsHotelOfferIdRoomsRoomTokenImagesFullscreenRouteImport } from './routes/_authenticated/hotels/_hotels/_hotel-offer/$id.rooms_.$roomToken.images_.fullscreen'

const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const SplatRoute = SplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedTravelersRoute = AuthenticatedTravelersRouteImport.update({
  id: '/travelers',
  path: '/travelers',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedChatRoute = AuthenticatedChatRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedBookingsRoute = AuthenticatedBookingsRouteImport.update({
  id: '/bookings',
  path: '/bookings',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedHotelsRouteRoute =
  AuthenticatedHotelsRouteRouteImport.update({
    id: '/hotels',
    path: '/hotels',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedFlightsRouteRoute =
  AuthenticatedFlightsRouteRouteImport.update({
    id: '/flights',
    path: '/flights',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTripsSearchRoute =
  AuthenticatedTripsSearchRouteImport.update({
    id: '/trips/search',
    path: '/trips/search',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHotelsSearchRoute =
  AuthenticatedHotelsSearchRouteImport.update({
    id: '/search',
    path: '/search',
    getParentRoute: () => AuthenticatedHotelsRouteRoute,
  } as any)
const AuthenticatedHotelsExternalRoute =
  AuthenticatedHotelsExternalRouteImport.update({
    id: '/external',
    path: '/external',
    getParentRoute: () => AuthenticatedHotelsRouteRoute,
  } as any)
const AuthenticatedFlightsSearchRoute =
  AuthenticatedFlightsSearchRouteImport.update({
    id: '/search',
    path: '/search',
    getParentRoute: () => AuthenticatedFlightsRouteRoute,
  } as any)
const AuthenticatedFlightsExternalRoute =
  AuthenticatedFlightsExternalRouteImport.update({
    id: '/external',
    path: '/external',
    getParentRoute: () => AuthenticatedFlightsRouteRoute,
  } as any)
const AuthenticatedTripsTripIdRouteRoute =
  AuthenticatedTripsTripIdRouteRouteImport.update({
    id: '/trips/$tripId',
    path: '/trips/$tripId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHotelsHotelsRouteRoute =
  AuthenticatedHotelsHotelsRouteRouteImport.update({
    id: '/_hotels',
    getParentRoute: () => AuthenticatedHotelsRouteRoute,
  } as any)
const AuthenticatedFlightsOffersRouteRoute =
  AuthenticatedFlightsOffersRouteRouteImport.update({
    id: '/_offers',
    getParentRoute: () => AuthenticatedFlightsRouteRoute,
  } as any)
const AuthenticatedTripsTripIdIndexRoute =
  AuthenticatedTripsTripIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedTripsTripIdRouteRoute,
  } as any)
const AuthenticatedTripsTripIdTravellersRoute =
  AuthenticatedTripsTripIdTravellersRouteImport.update({
    id: '/travellers',
    path: '/travellers',
    getParentRoute: () => AuthenticatedTripsTripIdRouteRoute,
  } as any)
const AuthenticatedTripsTripIdSummaryRoute =
  AuthenticatedTripsTripIdSummaryRouteImport.update({
    id: '/summary',
    path: '/summary',
    getParentRoute: () => AuthenticatedTripsTripIdRouteRoute,
  } as any)
const AuthenticatedTripsTripIdSuccessRoute =
  AuthenticatedTripsTripIdSuccessRouteImport.update({
    id: '/success',
    path: '/success',
    getParentRoute: () => AuthenticatedTripsTripIdRouteRoute,
  } as any)
const AuthenticatedTripsTripIdBookingRoute =
  AuthenticatedTripsTripIdBookingRouteImport.update({
    id: '/booking',
    path: '/booking',
    getParentRoute: () => AuthenticatedTripsTripIdRouteRoute,
  } as any)
const AuthenticatedHotelsHotelsListRoute =
  AuthenticatedHotelsHotelsListRouteImport.update({
    id: '/list',
    path: '/list',
    getParentRoute: () => AuthenticatedHotelsHotelsRouteRoute,
  } as any)
const AuthenticatedBookingsScopeIdRoute =
  AuthenticatedBookingsScopeIdRouteImport.update({
    id: '/bookings_/$scope/$id',
    path: '/bookings/$scope/$id',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHotelsHotelsHotelOfferRouteRoute =
  AuthenticatedHotelsHotelsHotelOfferRouteRouteImport.update({
    id: '/_hotel-offer',
    getParentRoute: () => AuthenticatedHotelsHotelsRouteRoute,
  } as any)
const AuthenticatedFlightsOffersOfferRouteRoute =
  AuthenticatedFlightsOffersOfferRouteRouteImport.update({
    id: '/offer',
    path: '/offer',
    getParentRoute: () => AuthenticatedFlightsOffersRouteRoute,
  } as any)
const AuthenticatedHotelsHotelsHotelOfferIdRoute =
  AuthenticatedHotelsHotelsHotelOfferIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthenticatedHotelsHotelsHotelOfferRouteRoute,
  } as any)
const AuthenticatedFlightsOffersReturnListRoute =
  AuthenticatedFlightsOffersReturnListRouteImport.update({
    id: '/return/list',
    path: '/return/list',
    getParentRoute: () => AuthenticatedFlightsOffersRouteRoute,
  } as any)
const AuthenticatedFlightsOffersReturnFareRoute =
  AuthenticatedFlightsOffersReturnFareRouteImport.update({
    id: '/return/fare',
    path: '/return/fare',
    getParentRoute: () => AuthenticatedFlightsOffersRouteRoute,
  } as any)
const AuthenticatedFlightsOffersDepartureListRoute =
  AuthenticatedFlightsOffersDepartureListRouteImport.update({
    id: '/departure/list',
    path: '/departure/list',
    getParentRoute: () => AuthenticatedFlightsOffersRouteRoute,
  } as any)
const AuthenticatedFlightsOffersDepartureFareRoute =
  AuthenticatedFlightsOffersDepartureFareRouteImport.update({
    id: '/departure/fare',
    path: '/departure/fare',
    getParentRoute: () => AuthenticatedFlightsOffersRouteRoute,
  } as any)
const AuthenticatedHotelsHotelsHotelOfferIdTravellersRoute =
  AuthenticatedHotelsHotelsHotelOfferIdTravellersRouteImport.update({
    id: '/travellers',
    path: '/travellers',
    getParentRoute: () => AuthenticatedHotelsHotelsHotelOfferIdRoute,
  } as any)
const AuthenticatedHotelsHotelsHotelOfferIdSummaryRoute =
  AuthenticatedHotelsHotelsHotelOfferIdSummaryRouteImport.update({
    id: '/summary',
    path: '/summary',
    getParentRoute: () => AuthenticatedHotelsHotelsHotelOfferIdRoute,
  } as any)
const AuthenticatedHotelsHotelsHotelOfferIdRoomsRoute =
  AuthenticatedHotelsHotelsHotelOfferIdRoomsRouteImport.update({
    id: '/rooms',
    path: '/rooms',
    getParentRoute: () => AuthenticatedHotelsHotelsHotelOfferIdRoute,
  } as any)
const AuthenticatedHotelsHotelsHotelOfferIdPaymentRoute =
  AuthenticatedHotelsHotelsHotelOfferIdPaymentRouteImport.update({
    id: '/payment',
    path: '/payment',
    getParentRoute: () => AuthenticatedHotelsHotelsHotelOfferIdRoute,
  } as any)
const AuthenticatedHotelsHotelsHotelOfferIdDetailsRoute =
  AuthenticatedHotelsHotelsHotelOfferIdDetailsRouteImport.update({
    id: '/details',
    path: '/details',
    getParentRoute: () => AuthenticatedHotelsHotelsHotelOfferIdRoute,
  } as any)
const AuthenticatedHotelsHotelsHotelOfferIdConfirmationRoute =
  AuthenticatedHotelsHotelsHotelOfferIdConfirmationRouteImport.update({
    id: '/confirmation',
    path: '/confirmation',
    getParentRoute: () => AuthenticatedHotelsHotelsHotelOfferIdRoute,
  } as any)
const AuthenticatedFlightsOffersOfferIdSummaryRoute =
  AuthenticatedFlightsOffersOfferIdSummaryRouteImport.update({
    id: '/$id/summary',
    path: '/$id/summary',
    getParentRoute: () => AuthenticatedFlightsOffersOfferRouteRoute,
  } as any)
const AuthenticatedFlightsOffersOfferIdPaymentRoute =
  AuthenticatedFlightsOffersOfferIdPaymentRouteImport.update({
    id: '/$id/payment',
    path: '/$id/payment',
    getParentRoute: () => AuthenticatedFlightsOffersOfferRouteRoute,
  } as any)
const AuthenticatedFlightsOffersOfferIdDetailsRoute =
  AuthenticatedFlightsOffersOfferIdDetailsRouteImport.update({
    id: '/$id/details',
    path: '/$id/details',
    getParentRoute: () => AuthenticatedFlightsOffersOfferRouteRoute,
  } as any)
const AuthenticatedFlightsOffersOfferIdConfirmationRoute =
  AuthenticatedFlightsOffersOfferIdConfirmationRouteImport.update({
    id: '/$id/confirmation',
    path: '/$id/confirmation',
    getParentRoute: () => AuthenticatedFlightsOffersOfferRouteRoute,
  } as any)
const AuthenticatedFlightsOffersOfferIdTravellersIndexRoute =
  AuthenticatedFlightsOffersOfferIdTravellersIndexRouteImport.update({
    id: '/$id/travellers/',
    path: '/$id/travellers/',
    getParentRoute: () => AuthenticatedFlightsOffersOfferRouteRoute,
  } as any)
const AuthenticatedHotelsHotelsHotelOfferIdDetailsImagesRoute =
  AuthenticatedHotelsHotelsHotelOfferIdDetailsImagesRouteImport.update({
    id: '/details_/images',
    path: '/details/images',
    getParentRoute: () => AuthenticatedHotelsHotelsHotelOfferIdRoute,
  } as any)
const AuthenticatedFlightsOffersOfferIdTravellersAdditionalServicesIndexRoute =
  AuthenticatedFlightsOffersOfferIdTravellersAdditionalServicesIndexRouteImport.update(
    {
      id: '/$id/travellers/additional-services/',
      path: '/$id/travellers/additional-services/',
      getParentRoute: () => AuthenticatedFlightsOffersOfferRouteRoute,
    } as any,
  )
const AuthenticatedHotelsHotelsHotelOfferIdDetailsImagesFullscreenRoute =
  AuthenticatedHotelsHotelsHotelOfferIdDetailsImagesFullscreenRouteImport.update(
    {
      id: '/details_/images_/fullscreen',
      path: '/details/images/fullscreen',
      getParentRoute: () => AuthenticatedHotelsHotelsHotelOfferIdRoute,
    } as any,
  )
const AuthenticatedFlightsOffersOfferIdTravellersAdditionalServicesMealSelectionRoute =
  AuthenticatedFlightsOffersOfferIdTravellersAdditionalServicesMealSelectionRouteImport.update(
    {
      id: '/$id/travellers/additional-services/meal-selection',
      path: '/$id/travellers/additional-services/meal-selection',
      getParentRoute: () => AuthenticatedFlightsOffersOfferRouteRoute,
    } as any,
  )
const AuthenticatedFlightsOffersOfferIdTravellersAdditionalServicesBaggageSelectionRoute =
  AuthenticatedFlightsOffersOfferIdTravellersAdditionalServicesBaggageSelectionRouteImport.update(
    {
      id: '/$id/travellers/additional-services/baggage-selection',
      path: '/$id/travellers/additional-services/baggage-selection',
      getParentRoute: () => AuthenticatedFlightsOffersOfferRouteRoute,
    } as any,
  )
const AuthenticatedHotelsHotelsHotelOfferIdRoomsRoomTokenImagesFullscreenRoute =
  AuthenticatedHotelsHotelsHotelOfferIdRoomsRoomTokenImagesFullscreenRouteImport.update(
    {
      id: '/rooms_/$roomToken/images_/fullscreen',
      path: '/rooms/$roomToken/images/fullscreen',
      getParentRoute: () => AuthenticatedHotelsHotelsHotelOfferIdRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/$': typeof SplatRoute
  '/flights': typeof AuthenticatedFlightsOffersRouteRouteWithChildren
  '/hotels': typeof AuthenticatedHotelsHotelsHotelOfferRouteRouteWithChildren
  '/bookings': typeof AuthenticatedBookingsRoute
  '/chat': typeof AuthenticatedChatRoute
  '/travelers': typeof AuthenticatedTravelersRoute
  '/': typeof AuthenticatedIndexRoute
  '/trips/$tripId': typeof AuthenticatedTripsTripIdRouteRouteWithChildren
  '/flights/external': typeof AuthenticatedFlightsExternalRoute
  '/flights/search': typeof AuthenticatedFlightsSearchRoute
  '/hotels/external': typeof AuthenticatedHotelsExternalRoute
  '/hotels/search': typeof AuthenticatedHotelsSearchRoute
  '/trips/search': typeof AuthenticatedTripsSearchRoute
  '/flights/offer': typeof AuthenticatedFlightsOffersOfferRouteRouteWithChildren
  '/bookings/$scope/$id': typeof AuthenticatedBookingsScopeIdRoute
  '/hotels/list': typeof AuthenticatedHotelsHotelsListRoute
  '/trips/$tripId/booking': typeof AuthenticatedTripsTripIdBookingRoute
  '/trips/$tripId/success': typeof AuthenticatedTripsTripIdSuccessRoute
  '/trips/$tripId/summary': typeof AuthenticatedTripsTripIdSummaryRoute
  '/trips/$tripId/travellers': typeof AuthenticatedTripsTripIdTravellersRoute
  '/trips/$tripId/': typeof AuthenticatedTripsTripIdIndexRoute
  '/flights/departure/fare': typeof AuthenticatedFlightsOffersDepartureFareRoute
  '/flights/departure/list': typeof AuthenticatedFlightsOffersDepartureListRoute
  '/flights/return/fare': typeof AuthenticatedFlightsOffersReturnFareRoute
  '/flights/return/list': typeof AuthenticatedFlightsOffersReturnListRoute
  '/hotels/$id': typeof AuthenticatedHotelsHotelsHotelOfferIdRouteWithChildren
  '/flights/offer/$id/confirmation': typeof AuthenticatedFlightsOffersOfferIdConfirmationRoute
  '/flights/offer/$id/details': typeof AuthenticatedFlightsOffersOfferIdDetailsRoute
  '/flights/offer/$id/payment': typeof AuthenticatedFlightsOffersOfferIdPaymentRoute
  '/flights/offer/$id/summary': typeof AuthenticatedFlightsOffersOfferIdSummaryRoute
  '/hotels/$id/confirmation': typeof AuthenticatedHotelsHotelsHotelOfferIdConfirmationRoute
  '/hotels/$id/details': typeof AuthenticatedHotelsHotelsHotelOfferIdDetailsRoute
  '/hotels/$id/payment': typeof AuthenticatedHotelsHotelsHotelOfferIdPaymentRoute
  '/hotels/$id/rooms': typeof AuthenticatedHotelsHotelsHotelOfferIdRoomsRoute
  '/hotels/$id/summary': typeof AuthenticatedHotelsHotelsHotelOfferIdSummaryRoute
  '/hotels/$id/travellers': typeof AuthenticatedHotelsHotelsHotelOfferIdTravellersRoute
  '/hotels/$id/details/images': typeof AuthenticatedHotelsHotelsHotelOfferIdDetailsImagesRoute
  '/flights/offer/$id/travellers': typeof AuthenticatedFlightsOffersOfferIdTravellersIndexRoute
  '/flights/offer/$id/travellers/additional-services/baggage-selection': typeof AuthenticatedFlightsOffersOfferIdTravellersAdditionalServicesBaggageSelectionRoute
  '/flights/offer/$id/travellers/additional-services/meal-selection': typeof AuthenticatedFlightsOffersOfferIdTravellersAdditionalServicesMealSelectionRoute
  '/hotels/$id/details/images/fullscreen': typeof AuthenticatedHotelsHotelsHotelOfferIdDetailsImagesFullscreenRoute
  '/flights/offer/$id/travellers/additional-services': typeof AuthenticatedFlightsOffersOfferIdTravellersAdditionalServicesIndexRoute
  '/hotels/$id/rooms/$roomToken/images/fullscreen': typeof AuthenticatedHotelsHotelsHotelOfferIdRoomsRoomTokenImagesFullscreenRoute
}
export interface FileRoutesByTo {
  '/$': typeof SplatRoute
  '/flights': typeof AuthenticatedFlightsOffersRouteRouteWithChildren
  '/hotels': typeof AuthenticatedHotelsHotelsHotelOfferRouteRouteWithChildren
  '/bookings': typeof AuthenticatedBookingsRoute
  '/chat': typeof AuthenticatedChatRoute
  '/travelers': typeof AuthenticatedTravelersRoute
  '/': typeof AuthenticatedIndexRoute
  '/flights/external': typeof AuthenticatedFlightsExternalRoute
  '/flights/search': typeof AuthenticatedFlightsSearchRoute
  '/hotels/external': typeof AuthenticatedHotelsExternalRoute
  '/hotels/search': typeof AuthenticatedHotelsSearchRoute
  '/trips/search': typeof AuthenticatedTripsSearchRoute
  '/flights/offer': typeof AuthenticatedFlightsOffersOfferRouteRouteWithChildren
  '/bookings/$scope/$id': typeof AuthenticatedBookingsScopeIdRoute
  '/hotels/list': typeof AuthenticatedHotelsHotelsListRoute
  '/trips/$tripId/booking': typeof AuthenticatedTripsTripIdBookingRoute
  '/trips/$tripId/success': typeof AuthenticatedTripsTripIdSuccessRoute
  '/trips/$tripId/summary': typeof AuthenticatedTripsTripIdSummaryRoute
  '/trips/$tripId/travellers': typeof AuthenticatedTripsTripIdTravellersRoute
  '/trips/$tripId': typeof AuthenticatedTripsTripIdIndexRoute
  '/flights/departure/fare': typeof AuthenticatedFlightsOffersDepartureFareRoute
  '/flights/departure/list': typeof AuthenticatedFlightsOffersDepartureListRoute
  '/flights/return/fare': typeof AuthenticatedFlightsOffersReturnFareRoute
  '/flights/return/list': typeof AuthenticatedFlightsOffersReturnListRoute
  '/hotels/$id': typeof AuthenticatedHotelsHotelsHotelOfferIdRouteWithChildren
  '/flights/offer/$id/confirmation': typeof AuthenticatedFlightsOffersOfferIdConfirmationRoute
  '/flights/offer/$id/details': typeof AuthenticatedFlightsOffersOfferIdDetailsRoute
  '/flights/offer/$id/payment': typeof AuthenticatedFlightsOffersOfferIdPaymentRoute
  '/flights/offer/$id/summary': typeof AuthenticatedFlightsOffersOfferIdSummaryRoute
  '/hotels/$id/confirmation': typeof AuthenticatedHotelsHotelsHotelOfferIdConfirmationRoute
  '/hotels/$id/details': typeof AuthenticatedHotelsHotelsHotelOfferIdDetailsRoute
  '/hotels/$id/payment': typeof AuthenticatedHotelsHotelsHotelOfferIdPaymentRoute
  '/hotels/$id/rooms': typeof AuthenticatedHotelsHotelsHotelOfferIdRoomsRoute
  '/hotels/$id/summary': typeof AuthenticatedHotelsHotelsHotelOfferIdSummaryRoute
  '/hotels/$id/travellers': typeof AuthenticatedHotelsHotelsHotelOfferIdTravellersRoute
  '/hotels/$id/details/images': typeof AuthenticatedHotelsHotelsHotelOfferIdDetailsImagesRoute
  '/flights/offer/$id/travellers': typeof AuthenticatedFlightsOffersOfferIdTravellersIndexRoute
  '/flights/offer/$id/travellers/additional-services/baggage-selection': typeof AuthenticatedFlightsOffersOfferIdTravellersAdditionalServicesBaggageSelectionRoute
  '/flights/offer/$id/travellers/additional-services/meal-selection': typeof AuthenticatedFlightsOffersOfferIdTravellersAdditionalServicesMealSelectionRoute
  '/hotels/$id/details/images/fullscreen': typeof AuthenticatedHotelsHotelsHotelOfferIdDetailsImagesFullscreenRoute
  '/flights/offer/$id/travellers/additional-services': typeof AuthenticatedFlightsOffersOfferIdTravellersAdditionalServicesIndexRoute
  '/hotels/$id/rooms/$roomToken/images/fullscreen': typeof AuthenticatedHotelsHotelsHotelOfferIdRoomsRoomTokenImagesFullscreenRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/$': typeof SplatRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_authenticated/flights': typeof AuthenticatedFlightsRouteRouteWithChildren
  '/_authenticated/hotels': typeof AuthenticatedHotelsRouteRouteWithChildren
  '/_authenticated/bookings': typeof AuthenticatedBookingsRoute
  '/_authenticated/chat': typeof AuthenticatedChatRoute
  '/_authenticated/travelers': typeof AuthenticatedTravelersRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/flights/_offers': typeof AuthenticatedFlightsOffersRouteRouteWithChildren
  '/_authenticated/hotels/_hotels': typeof AuthenticatedHotelsHotelsRouteRouteWithChildren
  '/_authenticated/trips/$tripId': typeof AuthenticatedTripsTripIdRouteRouteWithChildren
  '/_authenticated/flights/external': typeof AuthenticatedFlightsExternalRoute
  '/_authenticated/flights/search': typeof AuthenticatedFlightsSearchRoute
  '/_authenticated/hotels/external': typeof AuthenticatedHotelsExternalRoute
  '/_authenticated/hotels/search': typeof AuthenticatedHotelsSearchRoute
  '/_authenticated/trips/search': typeof AuthenticatedTripsSearchRoute
  '/_authenticated/flights/_offers/offer': typeof AuthenticatedFlightsOffersOfferRouteRouteWithChildren
  '/_authenticated/hotels/_hotels/_hotel-offer': typeof AuthenticatedHotelsHotelsHotelOfferRouteRouteWithChildren
  '/_authenticated/bookings_/$scope/$id': typeof AuthenticatedBookingsScopeIdRoute
  '/_authenticated/hotels/_hotels/list': typeof AuthenticatedHotelsHotelsListRoute
  '/_authenticated/trips/$tripId/booking': typeof AuthenticatedTripsTripIdBookingRoute
  '/_authenticated/trips/$tripId/success': typeof AuthenticatedTripsTripIdSuccessRoute
  '/_authenticated/trips/$tripId/summary': typeof AuthenticatedTripsTripIdSummaryRoute
  '/_authenticated/trips/$tripId/travellers': typeof AuthenticatedTripsTripIdTravellersRoute
  '/_authenticated/trips/$tripId/': typeof AuthenticatedTripsTripIdIndexRoute
  '/_authenticated/flights/_offers/departure/fare': typeof AuthenticatedFlightsOffersDepartureFareRoute
  '/_authenticated/flights/_offers/departure/list': typeof AuthenticatedFlightsOffersDepartureListRoute
  '/_authenticated/flights/_offers/return/fare': typeof AuthenticatedFlightsOffersReturnFareRoute
  '/_authenticated/flights/_offers/return/list': typeof AuthenticatedFlightsOffersReturnListRoute
  '/_authenticated/hotels/_hotels/_hotel-offer/$id': typeof AuthenticatedHotelsHotelsHotelOfferIdRouteWithChildren
  '/_authenticated/flights/_offers/offer/$id/confirmation': typeof AuthenticatedFlightsOffersOfferIdConfirmationRoute
  '/_authenticated/flights/_offers/offer/$id/details': typeof AuthenticatedFlightsOffersOfferIdDetailsRoute
  '/_authenticated/flights/_offers/offer/$id/payment': typeof AuthenticatedFlightsOffersOfferIdPaymentRoute
  '/_authenticated/flights/_offers/offer/$id/summary': typeof AuthenticatedFlightsOffersOfferIdSummaryRoute
  '/_authenticated/hotels/_hotels/_hotel-offer/$id/confirmation': typeof AuthenticatedHotelsHotelsHotelOfferIdConfirmationRoute
  '/_authenticated/hotels/_hotels/_hotel-offer/$id/details': typeof AuthenticatedHotelsHotelsHotelOfferIdDetailsRoute
  '/_authenticated/hotels/_hotels/_hotel-offer/$id/payment': typeof AuthenticatedHotelsHotelsHotelOfferIdPaymentRoute
  '/_authenticated/hotels/_hotels/_hotel-offer/$id/rooms': typeof AuthenticatedHotelsHotelsHotelOfferIdRoomsRoute
  '/_authenticated/hotels/_hotels/_hotel-offer/$id/summary': typeof AuthenticatedHotelsHotelsHotelOfferIdSummaryRoute
  '/_authenticated/hotels/_hotels/_hotel-offer/$id/travellers': typeof AuthenticatedHotelsHotelsHotelOfferIdTravellersRoute
  '/_authenticated/hotels/_hotels/_hotel-offer/$id/details_/images': typeof AuthenticatedHotelsHotelsHotelOfferIdDetailsImagesRoute
  '/_authenticated/flights/_offers/offer/$id/travellers/': typeof AuthenticatedFlightsOffersOfferIdTravellersIndexRoute
  '/_authenticated/flights/_offers/offer/$id/travellers/additional-services/baggage-selection': typeof AuthenticatedFlightsOffersOfferIdTravellersAdditionalServicesBaggageSelectionRoute
  '/_authenticated/flights/_offers/offer/$id/travellers/additional-services/meal-selection': typeof AuthenticatedFlightsOffersOfferIdTravellersAdditionalServicesMealSelectionRoute
  '/_authenticated/hotels/_hotels/_hotel-offer/$id/details_/images_/fullscreen': typeof AuthenticatedHotelsHotelsHotelOfferIdDetailsImagesFullscreenRoute
  '/_authenticated/flights/_offers/offer/$id/travellers/additional-services/': typeof AuthenticatedFlightsOffersOfferIdTravellersAdditionalServicesIndexRoute
  '/_authenticated/hotels/_hotels/_hotel-offer/$id/rooms_/$roomToken/images_/fullscreen': typeof AuthenticatedHotelsHotelsHotelOfferIdRoomsRoomTokenImagesFullscreenRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/$'
    | '/flights'
    | '/hotels'
    | '/bookings'
    | '/chat'
    | '/travelers'
    | '/'
    | '/trips/$tripId'
    | '/flights/external'
    | '/flights/search'
    | '/hotels/external'
    | '/hotels/search'
    | '/trips/search'
    | '/flights/offer'
    | '/bookings/$scope/$id'
    | '/hotels/list'
    | '/trips/$tripId/booking'
    | '/trips/$tripId/success'
    | '/trips/$tripId/summary'
    | '/trips/$tripId/travellers'
    | '/trips/$tripId/'
    | '/flights/departure/fare'
    | '/flights/departure/list'
    | '/flights/return/fare'
    | '/flights/return/list'
    | '/hotels/$id'
    | '/flights/offer/$id/confirmation'
    | '/flights/offer/$id/details'
    | '/flights/offer/$id/payment'
    | '/flights/offer/$id/summary'
    | '/hotels/$id/confirmation'
    | '/hotels/$id/details'
    | '/hotels/$id/payment'
    | '/hotels/$id/rooms'
    | '/hotels/$id/summary'
    | '/hotels/$id/travellers'
    | '/hotels/$id/details/images'
    | '/flights/offer/$id/travellers'
    | '/flights/offer/$id/travellers/additional-services/baggage-selection'
    | '/flights/offer/$id/travellers/additional-services/meal-selection'
    | '/hotels/$id/details/images/fullscreen'
    | '/flights/offer/$id/travellers/additional-services'
    | '/hotels/$id/rooms/$roomToken/images/fullscreen'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/$'
    | '/flights'
    | '/hotels'
    | '/bookings'
    | '/chat'
    | '/travelers'
    | '/'
    | '/flights/external'
    | '/flights/search'
    | '/hotels/external'
    | '/hotels/search'
    | '/trips/search'
    | '/flights/offer'
    | '/bookings/$scope/$id'
    | '/hotels/list'
    | '/trips/$tripId/booking'
    | '/trips/$tripId/success'
    | '/trips/$tripId/summary'
    | '/trips/$tripId/travellers'
    | '/trips/$tripId'
    | '/flights/departure/fare'
    | '/flights/departure/list'
    | '/flights/return/fare'
    | '/flights/return/list'
    | '/hotels/$id'
    | '/flights/offer/$id/confirmation'
    | '/flights/offer/$id/details'
    | '/flights/offer/$id/payment'
    | '/flights/offer/$id/summary'
    | '/hotels/$id/confirmation'
    | '/hotels/$id/details'
    | '/hotels/$id/payment'
    | '/hotels/$id/rooms'
    | '/hotels/$id/summary'
    | '/hotels/$id/travellers'
    | '/hotels/$id/details/images'
    | '/flights/offer/$id/travellers'
    | '/flights/offer/$id/travellers/additional-services/baggage-selection'
    | '/flights/offer/$id/travellers/additional-services/meal-selection'
    | '/hotels/$id/details/images/fullscreen'
    | '/flights/offer/$id/travellers/additional-services'
    | '/hotels/$id/rooms/$roomToken/images/fullscreen'
  id:
    | '__root__'
    | '/$'
    | '/_authenticated'
    | '/_authenticated/flights'
    | '/_authenticated/hotels'
    | '/_authenticated/bookings'
    | '/_authenticated/chat'
    | '/_authenticated/travelers'
    | '/_authenticated/'
    | '/_authenticated/flights/_offers'
    | '/_authenticated/hotels/_hotels'
    | '/_authenticated/trips/$tripId'
    | '/_authenticated/flights/external'
    | '/_authenticated/flights/search'
    | '/_authenticated/hotels/external'
    | '/_authenticated/hotels/search'
    | '/_authenticated/trips/search'
    | '/_authenticated/flights/_offers/offer'
    | '/_authenticated/hotels/_hotels/_hotel-offer'
    | '/_authenticated/bookings_/$scope/$id'
    | '/_authenticated/hotels/_hotels/list'
    | '/_authenticated/trips/$tripId/booking'
    | '/_authenticated/trips/$tripId/success'
    | '/_authenticated/trips/$tripId/summary'
    | '/_authenticated/trips/$tripId/travellers'
    | '/_authenticated/trips/$tripId/'
    | '/_authenticated/flights/_offers/departure/fare'
    | '/_authenticated/flights/_offers/departure/list'
    | '/_authenticated/flights/_offers/return/fare'
    | '/_authenticated/flights/_offers/return/list'
    | '/_authenticated/hotels/_hotels/_hotel-offer/$id'
    | '/_authenticated/flights/_offers/offer/$id/confirmation'
    | '/_authenticated/flights/_offers/offer/$id/details'
    | '/_authenticated/flights/_offers/offer/$id/payment'
    | '/_authenticated/flights/_offers/offer/$id/summary'
    | '/_authenticated/hotels/_hotels/_hotel-offer/$id/confirmation'
    | '/_authenticated/hotels/_hotels/_hotel-offer/$id/details'
    | '/_authenticated/hotels/_hotels/_hotel-offer/$id/payment'
    | '/_authenticated/hotels/_hotels/_hotel-offer/$id/rooms'
    | '/_authenticated/hotels/_hotels/_hotel-offer/$id/summary'
    | '/_authenticated/hotels/_hotels/_hotel-offer/$id/travellers'
    | '/_authenticated/hotels/_hotels/_hotel-offer/$id/details_/images'
    | '/_authenticated/flights/_offers/offer/$id/travellers/'
    | '/_authenticated/flights/_offers/offer/$id/travellers/additional-services/baggage-selection'
    | '/_authenticated/flights/_offers/offer/$id/travellers/additional-services/meal-selection'
    | '/_authenticated/hotels/_hotels/_hotel-offer/$id/details_/images_/fullscreen'
    | '/_authenticated/flights/_offers/offer/$id/travellers/additional-services/'
    | '/_authenticated/hotels/_hotels/_hotel-offer/$id/rooms_/$roomToken/images_/fullscreen'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  SplatRoute: typeof SplatRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$': {
      id: '/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof SplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/travelers': {
      id: '/_authenticated/travelers'
      path: '/travelers'
      fullPath: '/travelers'
      preLoaderRoute: typeof AuthenticatedTravelersRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/chat': {
      id: '/_authenticated/chat'
      path: '/chat'
      fullPath: '/chat'
      preLoaderRoute: typeof AuthenticatedChatRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/bookings': {
      id: '/_authenticated/bookings'
      path: '/bookings'
      fullPath: '/bookings'
      preLoaderRoute: typeof AuthenticatedBookingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hotels': {
      id: '/_authenticated/hotels'
      path: '/hotels'
      fullPath: '/hotels'
      preLoaderRoute: typeof AuthenticatedHotelsRouteRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/flights': {
      id: '/_authenticated/flights'
      path: '/flights'
      fullPath: '/flights'
      preLoaderRoute: typeof AuthenticatedFlightsRouteRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/trips/search': {
      id: '/_authenticated/trips/search'
      path: '/trips/search'
      fullPath: '/trips/search'
      preLoaderRoute: typeof AuthenticatedTripsSearchRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hotels/search': {
      id: '/_authenticated/hotels/search'
      path: '/search'
      fullPath: '/hotels/search'
      preLoaderRoute: typeof AuthenticatedHotelsSearchRouteImport
      parentRoute: typeof AuthenticatedHotelsRouteRoute
    }
    '/_authenticated/hotels/external': {
      id: '/_authenticated/hotels/external'
      path: '/external'
      fullPath: '/hotels/external'
      preLoaderRoute: typeof AuthenticatedHotelsExternalRouteImport
      parentRoute: typeof AuthenticatedHotelsRouteRoute
    }
    '/_authenticated/flights/search': {
      id: '/_authenticated/flights/search'
      path: '/search'
      fullPath: '/flights/search'
      preLoaderRoute: typeof AuthenticatedFlightsSearchRouteImport
      parentRoute: typeof AuthenticatedFlightsRouteRoute
    }
    '/_authenticated/flights/external': {
      id: '/_authenticated/flights/external'
      path: '/external'
      fullPath: '/flights/external'
      preLoaderRoute: typeof AuthenticatedFlightsExternalRouteImport
      parentRoute: typeof AuthenticatedFlightsRouteRoute
    }
    '/_authenticated/trips/$tripId': {
      id: '/_authenticated/trips/$tripId'
      path: '/trips/$tripId'
      fullPath: '/trips/$tripId'
      preLoaderRoute: typeof AuthenticatedTripsTripIdRouteRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hotels/_hotels': {
      id: '/_authenticated/hotels/_hotels'
      path: ''
      fullPath: '/hotels'
      preLoaderRoute: typeof AuthenticatedHotelsHotelsRouteRouteImport
      parentRoute: typeof AuthenticatedHotelsRouteRoute
    }
    '/_authenticated/flights/_offers': {
      id: '/_authenticated/flights/_offers'
      path: ''
      fullPath: '/flights'
      preLoaderRoute: typeof AuthenticatedFlightsOffersRouteRouteImport
      parentRoute: typeof AuthenticatedFlightsRouteRoute
    }
    '/_authenticated/trips/$tripId/': {
      id: '/_authenticated/trips/$tripId/'
      path: '/'
      fullPath: '/trips/$tripId/'
      preLoaderRoute: typeof AuthenticatedTripsTripIdIndexRouteImport
      parentRoute: typeof AuthenticatedTripsTripIdRouteRoute
    }
    '/_authenticated/trips/$tripId/travellers': {
      id: '/_authenticated/trips/$tripId/travellers'
      path: '/travellers'
      fullPath: '/trips/$tripId/travellers'
      preLoaderRoute: typeof AuthenticatedTripsTripIdTravellersRouteImport
      parentRoute: typeof AuthenticatedTripsTripIdRouteRoute
    }
    '/_authenticated/trips/$tripId/summary': {
      id: '/_authenticated/trips/$tripId/summary'
      path: '/summary'
      fullPath: '/trips/$tripId/summary'
      preLoaderRoute: typeof AuthenticatedTripsTripIdSummaryRouteImport
      parentRoute: typeof AuthenticatedTripsTripIdRouteRoute
    }
    '/_authenticated/trips/$tripId/success': {
      id: '/_authenticated/trips/$tripId/success'
      path: '/success'
      fullPath: '/trips/$tripId/success'
      preLoaderRoute: typeof AuthenticatedTripsTripIdSuccessRouteImport
      parentRoute: typeof AuthenticatedTripsTripIdRouteRoute
    }
    '/_authenticated/trips/$tripId/booking': {
      id: '/_authenticated/trips/$tripId/booking'
      path: '/booking'
      fullPath: '/trips/$tripId/booking'
      preLoaderRoute: typeof AuthenticatedTripsTripIdBookingRouteImport
      parentRoute: typeof AuthenticatedTripsTripIdRouteRoute
    }
    '/_authenticated/hotels/_hotels/list': {
      id: '/_authenticated/hotels/_hotels/list'
      path: '/list'
      fullPath: '/hotels/list'
      preLoaderRoute: typeof AuthenticatedHotelsHotelsListRouteImport
      parentRoute: typeof AuthenticatedHotelsHotelsRouteRoute
    }
    '/_authenticated/bookings_/$scope/$id': {
      id: '/_authenticated/bookings_/$scope/$id'
      path: '/bookings/$scope/$id'
      fullPath: '/bookings/$scope/$id'
      preLoaderRoute: typeof AuthenticatedBookingsScopeIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hotels/_hotels/_hotel-offer': {
      id: '/_authenticated/hotels/_hotels/_hotel-offer'
      path: ''
      fullPath: '/hotels'
      preLoaderRoute: typeof AuthenticatedHotelsHotelsHotelOfferRouteRouteImport
      parentRoute: typeof AuthenticatedHotelsHotelsRouteRoute
    }
    '/_authenticated/flights/_offers/offer': {
      id: '/_authenticated/flights/_offers/offer'
      path: '/offer'
      fullPath: '/flights/offer'
      preLoaderRoute: typeof AuthenticatedFlightsOffersOfferRouteRouteImport
      parentRoute: typeof AuthenticatedFlightsOffersRouteRoute
    }
    '/_authenticated/hotels/_hotels/_hotel-offer/$id': {
      id: '/_authenticated/hotels/_hotels/_hotel-offer/$id'
      path: '/$id'
      fullPath: '/hotels/$id'
      preLoaderRoute: typeof AuthenticatedHotelsHotelsHotelOfferIdRouteImport
      parentRoute: typeof AuthenticatedHotelsHotelsHotelOfferRouteRoute
    }
    '/_authenticated/flights/_offers/return/list': {
      id: '/_authenticated/flights/_offers/return/list'
      path: '/return/list'
      fullPath: '/flights/return/list'
      preLoaderRoute: typeof AuthenticatedFlightsOffersReturnListRouteImport
      parentRoute: typeof AuthenticatedFlightsOffersRouteRoute
    }
    '/_authenticated/flights/_offers/return/fare': {
      id: '/_authenticated/flights/_offers/return/fare'
      path: '/return/fare'
      fullPath: '/flights/return/fare'
      preLoaderRoute: typeof AuthenticatedFlightsOffersReturnFareRouteImport
      parentRoute: typeof AuthenticatedFlightsOffersRouteRoute
    }
    '/_authenticated/flights/_offers/departure/list': {
      id: '/_authenticated/flights/_offers/departure/list'
      path: '/departure/list'
      fullPath: '/flights/departure/list'
      preLoaderRoute: typeof AuthenticatedFlightsOffersDepartureListRouteImport
      parentRoute: typeof AuthenticatedFlightsOffersRouteRoute
    }
    '/_authenticated/flights/_offers/departure/fare': {
      id: '/_authenticated/flights/_offers/departure/fare'
      path: '/departure/fare'
      fullPath: '/flights/departure/fare'
      preLoaderRoute: typeof AuthenticatedFlightsOffersDepartureFareRouteImport
      parentRoute: typeof AuthenticatedFlightsOffersRouteRoute
    }
    '/_authenticated/hotels/_hotels/_hotel-offer/$id/travellers': {
      id: '/_authenticated/hotels/_hotels/_hotel-offer/$id/travellers'
      path: '/travellers'
      fullPath: '/hotels/$id/travellers'
      preLoaderRoute: typeof AuthenticatedHotelsHotelsHotelOfferIdTravellersRouteImport
      parentRoute: typeof AuthenticatedHotelsHotelsHotelOfferIdRoute
    }
    '/_authenticated/hotels/_hotels/_hotel-offer/$id/summary': {
      id: '/_authenticated/hotels/_hotels/_hotel-offer/$id/summary'
      path: '/summary'
      fullPath: '/hotels/$id/summary'
      preLoaderRoute: typeof AuthenticatedHotelsHotelsHotelOfferIdSummaryRouteImport
      parentRoute: typeof AuthenticatedHotelsHotelsHotelOfferIdRoute
    }
    '/_authenticated/hotels/_hotels/_hotel-offer/$id/rooms': {
      id: '/_authenticated/hotels/_hotels/_hotel-offer/$id/rooms'
      path: '/rooms'
      fullPath: '/hotels/$id/rooms'
      preLoaderRoute: typeof AuthenticatedHotelsHotelsHotelOfferIdRoomsRouteImport
      parentRoute: typeof AuthenticatedHotelsHotelsHotelOfferIdRoute
    }
    '/_authenticated/hotels/_hotels/_hotel-offer/$id/payment': {
      id: '/_authenticated/hotels/_hotels/_hotel-offer/$id/payment'
      path: '/payment'
      fullPath: '/hotels/$id/payment'
      preLoaderRoute: typeof AuthenticatedHotelsHotelsHotelOfferIdPaymentRouteImport
      parentRoute: typeof AuthenticatedHotelsHotelsHotelOfferIdRoute
    }
    '/_authenticated/hotels/_hotels/_hotel-offer/$id/details': {
      id: '/_authenticated/hotels/_hotels/_hotel-offer/$id/details'
      path: '/details'
      fullPath: '/hotels/$id/details'
      preLoaderRoute: typeof AuthenticatedHotelsHotelsHotelOfferIdDetailsRouteImport
      parentRoute: typeof AuthenticatedHotelsHotelsHotelOfferIdRoute
    }
    '/_authenticated/hotels/_hotels/_hotel-offer/$id/confirmation': {
      id: '/_authenticated/hotels/_hotels/_hotel-offer/$id/confirmation'
      path: '/confirmation'
      fullPath: '/hotels/$id/confirmation'
      preLoaderRoute: typeof AuthenticatedHotelsHotelsHotelOfferIdConfirmationRouteImport
      parentRoute: typeof AuthenticatedHotelsHotelsHotelOfferIdRoute
    }
    '/_authenticated/flights/_offers/offer/$id/summary': {
      id: '/_authenticated/flights/_offers/offer/$id/summary'
      path: '/$id/summary'
      fullPath: '/flights/offer/$id/summary'
      preLoaderRoute: typeof AuthenticatedFlightsOffersOfferIdSummaryRouteImport
      parentRoute: typeof AuthenticatedFlightsOffersOfferRouteRoute
    }
    '/_authenticated/flights/_offers/offer/$id/payment': {
      id: '/_authenticated/flights/_offers/offer/$id/payment'
      path: '/$id/payment'
      fullPath: '/flights/offer/$id/payment'
      preLoaderRoute: typeof AuthenticatedFlightsOffersOfferIdPaymentRouteImport
      parentRoute: typeof AuthenticatedFlightsOffersOfferRouteRoute
    }
    '/_authenticated/flights/_offers/offer/$id/details': {
      id: '/_authenticated/flights/_offers/offer/$id/details'
      path: '/$id/details'
      fullPath: '/flights/offer/$id/details'
      preLoaderRoute: typeof AuthenticatedFlightsOffersOfferIdDetailsRouteImport
      parentRoute: typeof AuthenticatedFlightsOffersOfferRouteRoute
    }
    '/_authenticated/flights/_offers/offer/$id/confirmation': {
      id: '/_authenticated/flights/_offers/offer/$id/confirmation'
      path: '/$id/confirmation'
      fullPath: '/flights/offer/$id/confirmation'
      preLoaderRoute: typeof AuthenticatedFlightsOffersOfferIdConfirmationRouteImport
      parentRoute: typeof AuthenticatedFlightsOffersOfferRouteRoute
    }
    '/_authenticated/flights/_offers/offer/$id/travellers/': {
      id: '/_authenticated/flights/_offers/offer/$id/travellers/'
      path: '/$id/travellers'
      fullPath: '/flights/offer/$id/travellers'
      preLoaderRoute: typeof AuthenticatedFlightsOffersOfferIdTravellersIndexRouteImport
      parentRoute: typeof AuthenticatedFlightsOffersOfferRouteRoute
    }
    '/_authenticated/hotels/_hotels/_hotel-offer/$id/details_/images': {
      id: '/_authenticated/hotels/_hotels/_hotel-offer/$id/details_/images'
      path: '/details/images'
      fullPath: '/hotels/$id/details/images'
      preLoaderRoute: typeof AuthenticatedHotelsHotelsHotelOfferIdDetailsImagesRouteImport
      parentRoute: typeof AuthenticatedHotelsHotelsHotelOfferIdRoute
    }
    '/_authenticated/flights/_offers/offer/$id/travellers/additional-services/': {
      id: '/_authenticated/flights/_offers/offer/$id/travellers/additional-services/'
      path: '/$id/travellers/additional-services'
      fullPath: '/flights/offer/$id/travellers/additional-services'
      preLoaderRoute: typeof AuthenticatedFlightsOffersOfferIdTravellersAdditionalServicesIndexRouteImport
      parentRoute: typeof AuthenticatedFlightsOffersOfferRouteRoute
    }
    '/_authenticated/hotels/_hotels/_hotel-offer/$id/details_/images_/fullscreen': {
      id: '/_authenticated/hotels/_hotels/_hotel-offer/$id/details_/images_/fullscreen'
      path: '/details/images/fullscreen'
      fullPath: '/hotels/$id/details/images/fullscreen'
      preLoaderRoute: typeof AuthenticatedHotelsHotelsHotelOfferIdDetailsImagesFullscreenRouteImport
      parentRoute: typeof AuthenticatedHotelsHotelsHotelOfferIdRoute
    }
    '/_authenticated/flights/_offers/offer/$id/travellers/additional-services/meal-selection': {
      id: '/_authenticated/flights/_offers/offer/$id/travellers/additional-services/meal-selection'
      path: '/$id/travellers/additional-services/meal-selection'
      fullPath: '/flights/offer/$id/travellers/additional-services/meal-selection'
      preLoaderRoute: typeof AuthenticatedFlightsOffersOfferIdTravellersAdditionalServicesMealSelectionRouteImport
      parentRoute: typeof AuthenticatedFlightsOffersOfferRouteRoute
    }
    '/_authenticated/flights/_offers/offer/$id/travellers/additional-services/baggage-selection': {
      id: '/_authenticated/flights/_offers/offer/$id/travellers/additional-services/baggage-selection'
      path: '/$id/travellers/additional-services/baggage-selection'
      fullPath: '/flights/offer/$id/travellers/additional-services/baggage-selection'
      preLoaderRoute: typeof AuthenticatedFlightsOffersOfferIdTravellersAdditionalServicesBaggageSelectionRouteImport
      parentRoute: typeof AuthenticatedFlightsOffersOfferRouteRoute
    }
    '/_authenticated/hotels/_hotels/_hotel-offer/$id/rooms_/$roomToken/images_/fullscreen': {
      id: '/_authenticated/hotels/_hotels/_hotel-offer/$id/rooms_/$roomToken/images_/fullscreen'
      path: '/rooms/$roomToken/images/fullscreen'
      fullPath: '/hotels/$id/rooms/$roomToken/images/fullscreen'
      preLoaderRoute: typeof AuthenticatedHotelsHotelsHotelOfferIdRoomsRoomTokenImagesFullscreenRouteImport
      parentRoute: typeof AuthenticatedHotelsHotelsHotelOfferIdRoute
    }
  }
}

interface AuthenticatedFlightsOffersOfferRouteRouteChildren {
  AuthenticatedFlightsOffersOfferIdConfirmationRoute: typeof AuthenticatedFlightsOffersOfferIdConfirmationRoute
  AuthenticatedFlightsOffersOfferIdDetailsRoute: typeof AuthenticatedFlightsOffersOfferIdDetailsRoute
  AuthenticatedFlightsOffersOfferIdPaymentRoute: typeof AuthenticatedFlightsOffersOfferIdPaymentRoute
  AuthenticatedFlightsOffersOfferIdSummaryRoute: typeof AuthenticatedFlightsOffersOfferIdSummaryRoute
  AuthenticatedFlightsOffersOfferIdTravellersIndexRoute: typeof AuthenticatedFlightsOffersOfferIdTravellersIndexRoute
  AuthenticatedFlightsOffersOfferIdTravellersAdditionalServicesBaggageSelectionRoute: typeof AuthenticatedFlightsOffersOfferIdTravellersAdditionalServicesBaggageSelectionRoute
  AuthenticatedFlightsOffersOfferIdTravellersAdditionalServicesMealSelectionRoute: typeof AuthenticatedFlightsOffersOfferIdTravellersAdditionalServicesMealSelectionRoute
  AuthenticatedFlightsOffersOfferIdTravellersAdditionalServicesIndexRoute: typeof AuthenticatedFlightsOffersOfferIdTravellersAdditionalServicesIndexRoute
}

const AuthenticatedFlightsOffersOfferRouteRouteChildren: AuthenticatedFlightsOffersOfferRouteRouteChildren =
  {
    AuthenticatedFlightsOffersOfferIdConfirmationRoute:
      AuthenticatedFlightsOffersOfferIdConfirmationRoute,
    AuthenticatedFlightsOffersOfferIdDetailsRoute:
      AuthenticatedFlightsOffersOfferIdDetailsRoute,
    AuthenticatedFlightsOffersOfferIdPaymentRoute:
      AuthenticatedFlightsOffersOfferIdPaymentRoute,
    AuthenticatedFlightsOffersOfferIdSummaryRoute:
      AuthenticatedFlightsOffersOfferIdSummaryRoute,
    AuthenticatedFlightsOffersOfferIdTravellersIndexRoute:
      AuthenticatedFlightsOffersOfferIdTravellersIndexRoute,
    AuthenticatedFlightsOffersOfferIdTravellersAdditionalServicesBaggageSelectionRoute:
      AuthenticatedFlightsOffersOfferIdTravellersAdditionalServicesBaggageSelectionRoute,
    AuthenticatedFlightsOffersOfferIdTravellersAdditionalServicesMealSelectionRoute:
      AuthenticatedFlightsOffersOfferIdTravellersAdditionalServicesMealSelectionRoute,
    AuthenticatedFlightsOffersOfferIdTravellersAdditionalServicesIndexRoute:
      AuthenticatedFlightsOffersOfferIdTravellersAdditionalServicesIndexRoute,
  }

const AuthenticatedFlightsOffersOfferRouteRouteWithChildren =
  AuthenticatedFlightsOffersOfferRouteRoute._addFileChildren(
    AuthenticatedFlightsOffersOfferRouteRouteChildren,
  )

interface AuthenticatedFlightsOffersRouteRouteChildren {
  AuthenticatedFlightsOffersOfferRouteRoute: typeof AuthenticatedFlightsOffersOfferRouteRouteWithChildren
  AuthenticatedFlightsOffersDepartureFareRoute: typeof AuthenticatedFlightsOffersDepartureFareRoute
  AuthenticatedFlightsOffersDepartureListRoute: typeof AuthenticatedFlightsOffersDepartureListRoute
  AuthenticatedFlightsOffersReturnFareRoute: typeof AuthenticatedFlightsOffersReturnFareRoute
  AuthenticatedFlightsOffersReturnListRoute: typeof AuthenticatedFlightsOffersReturnListRoute
}

const AuthenticatedFlightsOffersRouteRouteChildren: AuthenticatedFlightsOffersRouteRouteChildren =
  {
    AuthenticatedFlightsOffersOfferRouteRoute:
      AuthenticatedFlightsOffersOfferRouteRouteWithChildren,
    AuthenticatedFlightsOffersDepartureFareRoute:
      AuthenticatedFlightsOffersDepartureFareRoute,
    AuthenticatedFlightsOffersDepartureListRoute:
      AuthenticatedFlightsOffersDepartureListRoute,
    AuthenticatedFlightsOffersReturnFareRoute:
      AuthenticatedFlightsOffersReturnFareRoute,
    AuthenticatedFlightsOffersReturnListRoute:
      AuthenticatedFlightsOffersReturnListRoute,
  }

const AuthenticatedFlightsOffersRouteRouteWithChildren =
  AuthenticatedFlightsOffersRouteRoute._addFileChildren(
    AuthenticatedFlightsOffersRouteRouteChildren,
  )

interface AuthenticatedFlightsRouteRouteChildren {
  AuthenticatedFlightsOffersRouteRoute: typeof AuthenticatedFlightsOffersRouteRouteWithChildren
  AuthenticatedFlightsExternalRoute: typeof AuthenticatedFlightsExternalRoute
  AuthenticatedFlightsSearchRoute: typeof AuthenticatedFlightsSearchRoute
}

const AuthenticatedFlightsRouteRouteChildren: AuthenticatedFlightsRouteRouteChildren =
  {
    AuthenticatedFlightsOffersRouteRoute:
      AuthenticatedFlightsOffersRouteRouteWithChildren,
    AuthenticatedFlightsExternalRoute: AuthenticatedFlightsExternalRoute,
    AuthenticatedFlightsSearchRoute: AuthenticatedFlightsSearchRoute,
  }

const AuthenticatedFlightsRouteRouteWithChildren =
  AuthenticatedFlightsRouteRoute._addFileChildren(
    AuthenticatedFlightsRouteRouteChildren,
  )

interface AuthenticatedHotelsHotelsHotelOfferIdRouteChildren {
  AuthenticatedHotelsHotelsHotelOfferIdConfirmationRoute: typeof AuthenticatedHotelsHotelsHotelOfferIdConfirmationRoute
  AuthenticatedHotelsHotelsHotelOfferIdDetailsRoute: typeof AuthenticatedHotelsHotelsHotelOfferIdDetailsRoute
  AuthenticatedHotelsHotelsHotelOfferIdPaymentRoute: typeof AuthenticatedHotelsHotelsHotelOfferIdPaymentRoute
  AuthenticatedHotelsHotelsHotelOfferIdRoomsRoute: typeof AuthenticatedHotelsHotelsHotelOfferIdRoomsRoute
  AuthenticatedHotelsHotelsHotelOfferIdSummaryRoute: typeof AuthenticatedHotelsHotelsHotelOfferIdSummaryRoute
  AuthenticatedHotelsHotelsHotelOfferIdTravellersRoute: typeof AuthenticatedHotelsHotelsHotelOfferIdTravellersRoute
  AuthenticatedHotelsHotelsHotelOfferIdDetailsImagesRoute: typeof AuthenticatedHotelsHotelsHotelOfferIdDetailsImagesRoute
  AuthenticatedHotelsHotelsHotelOfferIdDetailsImagesFullscreenRoute: typeof AuthenticatedHotelsHotelsHotelOfferIdDetailsImagesFullscreenRoute
  AuthenticatedHotelsHotelsHotelOfferIdRoomsRoomTokenImagesFullscreenRoute: typeof AuthenticatedHotelsHotelsHotelOfferIdRoomsRoomTokenImagesFullscreenRoute
}

const AuthenticatedHotelsHotelsHotelOfferIdRouteChildren: AuthenticatedHotelsHotelsHotelOfferIdRouteChildren =
  {
    AuthenticatedHotelsHotelsHotelOfferIdConfirmationRoute:
      AuthenticatedHotelsHotelsHotelOfferIdConfirmationRoute,
    AuthenticatedHotelsHotelsHotelOfferIdDetailsRoute:
      AuthenticatedHotelsHotelsHotelOfferIdDetailsRoute,
    AuthenticatedHotelsHotelsHotelOfferIdPaymentRoute:
      AuthenticatedHotelsHotelsHotelOfferIdPaymentRoute,
    AuthenticatedHotelsHotelsHotelOfferIdRoomsRoute:
      AuthenticatedHotelsHotelsHotelOfferIdRoomsRoute,
    AuthenticatedHotelsHotelsHotelOfferIdSummaryRoute:
      AuthenticatedHotelsHotelsHotelOfferIdSummaryRoute,
    AuthenticatedHotelsHotelsHotelOfferIdTravellersRoute:
      AuthenticatedHotelsHotelsHotelOfferIdTravellersRoute,
    AuthenticatedHotelsHotelsHotelOfferIdDetailsImagesRoute:
      AuthenticatedHotelsHotelsHotelOfferIdDetailsImagesRoute,
    AuthenticatedHotelsHotelsHotelOfferIdDetailsImagesFullscreenRoute:
      AuthenticatedHotelsHotelsHotelOfferIdDetailsImagesFullscreenRoute,
    AuthenticatedHotelsHotelsHotelOfferIdRoomsRoomTokenImagesFullscreenRoute:
      AuthenticatedHotelsHotelsHotelOfferIdRoomsRoomTokenImagesFullscreenRoute,
  }

const AuthenticatedHotelsHotelsHotelOfferIdRouteWithChildren =
  AuthenticatedHotelsHotelsHotelOfferIdRoute._addFileChildren(
    AuthenticatedHotelsHotelsHotelOfferIdRouteChildren,
  )

interface AuthenticatedHotelsHotelsHotelOfferRouteRouteChildren {
  AuthenticatedHotelsHotelsHotelOfferIdRoute: typeof AuthenticatedHotelsHotelsHotelOfferIdRouteWithChildren
}

const AuthenticatedHotelsHotelsHotelOfferRouteRouteChildren: AuthenticatedHotelsHotelsHotelOfferRouteRouteChildren =
  {
    AuthenticatedHotelsHotelsHotelOfferIdRoute:
      AuthenticatedHotelsHotelsHotelOfferIdRouteWithChildren,
  }

const AuthenticatedHotelsHotelsHotelOfferRouteRouteWithChildren =
  AuthenticatedHotelsHotelsHotelOfferRouteRoute._addFileChildren(
    AuthenticatedHotelsHotelsHotelOfferRouteRouteChildren,
  )

interface AuthenticatedHotelsHotelsRouteRouteChildren {
  AuthenticatedHotelsHotelsHotelOfferRouteRoute: typeof AuthenticatedHotelsHotelsHotelOfferRouteRouteWithChildren
  AuthenticatedHotelsHotelsListRoute: typeof AuthenticatedHotelsHotelsListRoute
}

const AuthenticatedHotelsHotelsRouteRouteChildren: AuthenticatedHotelsHotelsRouteRouteChildren =
  {
    AuthenticatedHotelsHotelsHotelOfferRouteRoute:
      AuthenticatedHotelsHotelsHotelOfferRouteRouteWithChildren,
    AuthenticatedHotelsHotelsListRoute: AuthenticatedHotelsHotelsListRoute,
  }

const AuthenticatedHotelsHotelsRouteRouteWithChildren =
  AuthenticatedHotelsHotelsRouteRoute._addFileChildren(
    AuthenticatedHotelsHotelsRouteRouteChildren,
  )

interface AuthenticatedHotelsRouteRouteChildren {
  AuthenticatedHotelsHotelsRouteRoute: typeof AuthenticatedHotelsHotelsRouteRouteWithChildren
  AuthenticatedHotelsExternalRoute: typeof AuthenticatedHotelsExternalRoute
  AuthenticatedHotelsSearchRoute: typeof AuthenticatedHotelsSearchRoute
}

const AuthenticatedHotelsRouteRouteChildren: AuthenticatedHotelsRouteRouteChildren =
  {
    AuthenticatedHotelsHotelsRouteRoute:
      AuthenticatedHotelsHotelsRouteRouteWithChildren,
    AuthenticatedHotelsExternalRoute: AuthenticatedHotelsExternalRoute,
    AuthenticatedHotelsSearchRoute: AuthenticatedHotelsSearchRoute,
  }

const AuthenticatedHotelsRouteRouteWithChildren =
  AuthenticatedHotelsRouteRoute._addFileChildren(
    AuthenticatedHotelsRouteRouteChildren,
  )

interface AuthenticatedTripsTripIdRouteRouteChildren {
  AuthenticatedTripsTripIdBookingRoute: typeof AuthenticatedTripsTripIdBookingRoute
  AuthenticatedTripsTripIdSuccessRoute: typeof AuthenticatedTripsTripIdSuccessRoute
  AuthenticatedTripsTripIdSummaryRoute: typeof AuthenticatedTripsTripIdSummaryRoute
  AuthenticatedTripsTripIdTravellersRoute: typeof AuthenticatedTripsTripIdTravellersRoute
  AuthenticatedTripsTripIdIndexRoute: typeof AuthenticatedTripsTripIdIndexRoute
}

const AuthenticatedTripsTripIdRouteRouteChildren: AuthenticatedTripsTripIdRouteRouteChildren =
  {
    AuthenticatedTripsTripIdBookingRoute: AuthenticatedTripsTripIdBookingRoute,
    AuthenticatedTripsTripIdSuccessRoute: AuthenticatedTripsTripIdSuccessRoute,
    AuthenticatedTripsTripIdSummaryRoute: AuthenticatedTripsTripIdSummaryRoute,
    AuthenticatedTripsTripIdTravellersRoute:
      AuthenticatedTripsTripIdTravellersRoute,
    AuthenticatedTripsTripIdIndexRoute: AuthenticatedTripsTripIdIndexRoute,
  }

const AuthenticatedTripsTripIdRouteRouteWithChildren =
  AuthenticatedTripsTripIdRouteRoute._addFileChildren(
    AuthenticatedTripsTripIdRouteRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedFlightsRouteRoute: typeof AuthenticatedFlightsRouteRouteWithChildren
  AuthenticatedHotelsRouteRoute: typeof AuthenticatedHotelsRouteRouteWithChildren
  AuthenticatedBookingsRoute: typeof AuthenticatedBookingsRoute
  AuthenticatedChatRoute: typeof AuthenticatedChatRoute
  AuthenticatedTravelersRoute: typeof AuthenticatedTravelersRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedTripsTripIdRouteRoute: typeof AuthenticatedTripsTripIdRouteRouteWithChildren
  AuthenticatedTripsSearchRoute: typeof AuthenticatedTripsSearchRoute
  AuthenticatedBookingsScopeIdRoute: typeof AuthenticatedBookingsScopeIdRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedFlightsRouteRoute: AuthenticatedFlightsRouteRouteWithChildren,
  AuthenticatedHotelsRouteRoute: AuthenticatedHotelsRouteRouteWithChildren,
  AuthenticatedBookingsRoute: AuthenticatedBookingsRoute,
  AuthenticatedChatRoute: AuthenticatedChatRoute,
  AuthenticatedTravelersRoute: AuthenticatedTravelersRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedTripsTripIdRouteRoute:
    AuthenticatedTripsTripIdRouteRouteWithChildren,
  AuthenticatedTripsSearchRoute: AuthenticatedTripsSearchRoute,
  AuthenticatedBookingsScopeIdRoute: AuthenticatedBookingsScopeIdRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  SplatRoute: SplatRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
